import { render, staticRenderFns } from "./CorpFlowVotesPage.vue?vue&type=template&id=2280d752&scoped=true"
import script from "./CorpFlowVotesPage.vue?vue&type=script&lang=js"
export * from "./CorpFlowVotesPage.vue?vue&type=script&lang=js"
import style0 from "./CorpFlowVotesPage.vue?vue&type=style&index=0&id=2280d752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280d752",
  null
  
)

export default component.exports